export class AdminLandingLead {
  id = 0

  name: string | null = null

  businessName: string | null = null

  email: string | null = null

  phoneNumber: string | null = null

  trafficSource: string | null = null

  formName: string | null = null

  answers: { label: string; value: string }[] = []

  hasBeenContacted = false

  createdAt = ""

  constructor(data: Partial<AdminLandingLead> = {}) { Object.assign(this, data) }
}
